import styled from 'styled-components';
import { COLOR_NEUTRAL_10 } from 'constants/colors';

export const ClickableCrumb = styled.button`
  background: transparent;
  font-size: 0.875rem;
  outline: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${COLOR_NEUTRAL_10};
  }
`;
